import ShaderProgram from "../lib/ShaderProgram";

class VerticalFintechHero {
    constructor(canvas) {
        this.canvas = canvas;
        this.animate();
    }

    animate() {
        const pointSize = 2.5
        const radiansPerDegree = Math.PI / 180;

        const waves = new ShaderProgram(this.canvas, {
            texture: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJHRSTlMAC/goGvDhmwcExrVjWzrm29TRqqSKenRXVklANSIUE8mRkGpv+HOfAAABCElEQVQ4y4VT13LDMAwLrUHteO+R9f/fWMfO6dLaPeKVEECRxOULWsEGpS9nULDwia2Y+ALqUNbAWeg775zv+sA4/FFRMxt8U2FZFCVWjR/YrH4/H9sarclSKdPMWKzb8VsEeHB3m0shkhVCyNzeXeAQ9Xl4opEieX2QCGnwGbj6GMyjw9t1K0fK9YZunPXeAGsfJtYjwzxaBnozGGorYz0ypK2HzQSYx1y8DgSRo2ewOiyh2QWOEk1Y9OrQV0a8TiBM1a8eMHWYnRMy7CZ4t1CmyRkhSUvP3gRXyHOCLBxNoC3IJv//ZrJ/kxxUHPUB+6jJZZHrpg6GOjnqaOmzp4NDR48OLxn/H27SRQ08S0ZJAAAAAElFTkSuQmCC',
            uniforms: {
                size: {type: 'float', value: pointSize},
                field: {type: 'vec3', value: [0, 0, 0]},
                speed: {type: 'float', value: 5},
                cameraRotation: {
                    type: 'vec3',
                    value: [
                        -45 * radiansPerDegree,
                        15 * radiansPerDegree,
                        15 * radiansPerDegree
                    ]
                },
                cameraTranslation: {
                    type: 'vec3',
                    value: [
                        0,
                        70,
                        0
                    ]
                },
                cameraScale: {type: 'vec3', value: [1, 1, 1]},
            },
            vertex: `
                #define M_PI 3.1415926535897932384626433832795
            
                precision highp float;
            
                attribute vec4 a_position;
                attribute vec4 a_color;
            
                uniform float u_time;
                uniform float u_size;
                uniform float u_speed;
                uniform vec3 u_field;
                uniform mat4 u_projection;
                uniform vec3 u_cameraRotation;
                uniform vec3 u_cameraTranslation;
                uniform vec3 u_cameraScale;
            
                varying vec4 v_color;
            
                mat4 rotationMatrix(vec3 axis, float angle) {
                  axis = normalize(axis);
                  float s = sin(angle);
                  float c = cos(angle);
                  float oc = 1.0 - c;
            
                  return mat4(
                    oc * axis.x * axis.x + c,
                    oc * axis.x * axis.y - axis.z * s,
                    oc * axis.z * axis.x + axis.y * s,
                    0.0,
                    oc * axis.x * axis.y + axis.z * s,
                    oc * axis.y * axis.y + c,
                    oc * axis.y * axis.z - axis.x * s,
                    0.0,
                    oc * axis.z * axis.x - axis.y * s,
                    oc * axis.y * axis.z + axis.x * s,
                    oc * axis.z * axis.z + c,
                    0.0,
                    0.0, 0.0, 0.0, 1.0
                  );
                }
            
                void main() {
            
                  vec3 pos = a_position.xyz;
            
                  pos.y += (
                    cos(pos.x / u_field.x * M_PI * 8.0 + u_time * u_speed) +
                    sin(pos.z / u_field.z * M_PI * 8.0 + u_time * u_speed)
                  ) * u_field.y;
            
                  pos = (rotationMatrix(vec3(1.0, 0.0, 0.0), u_cameraRotation.x) * vec4(pos, 1.0)).xyz;
                  pos = (rotationMatrix(vec3(0.0, 1.0, 0.0), u_cameraRotation.y) * vec4(pos, 1.0)).xyz;
                  pos = (rotationMatrix(vec3(0.0, 0.0, 1.0), u_cameraRotation.z) * vec4(pos, 1.0)).xyz;
            
                  pos += u_cameraTranslation;
            
                  pos *= u_cameraScale;
                  
                  gl_Position = u_projection * vec4( pos.xyz, a_position.w );
                  gl_PointSize = ( u_size / gl_Position.w ) * 100.0;
            
                  v_color = a_color;
            
                }`,
            fragment: `
                precision highp float;
                
                uniform sampler2D u_texture;
                
                varying vec4 v_color;
                
                void main() {
                
                    gl_FragColor = v_color * texture2D(u_texture, gl_PointCoord);
                
                }`,

            onResize(w, h, dpi) {

                const position = [], color = []

                const width = 400 * (w / h)
                const depth = 400
                const height = 8
                const distance = 1

                for (let x = 0; x < width; x += distance) {
                    for (let z = 0; z < depth; z += distance) {

                        position.push(-width / 2 + x, -30, -depth / 2 + z)
                        color.push(0, 1 - (x / width) * 1, 0.5 + x / width * 0.5, z / depth)

                    }
                }

                this.uniforms.field = [width, height, depth]

                this.buffers.position = position
                this.buffers.color = color

                this.uniforms.size = (h / 400) * pointSize * dpi

            },
        })

    }
}

export default VerticalFintechHero;
